import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// import Dashboard from '@/components/pages/dashboard';
import RepairList from '@/components/pages/repair-list';
import UserInfo from '@/components/pages/info';
const ReportRepair = r => require.ensure([], () => r(require('@/components/pages/report-repair')), 'repairchunk');
const ReportQueryInfo = r => require.ensure([], () => r(require('@/components/pages/report-queryinfo')), 'repairchunk');
const ReportRepairFast = r => require.ensure([], () => r(require('@/components/pages/report-repair-fast')), 'repairchunk');
const ReportView = r => require.ensure([], () => r(require('@/components/pages/report-view')), 'repairchunk');
const ReportServiceTicketView = r => require.ensure([], () => r(require('@/components/pages/service-ticket-view')), 'repairchunk');

export default new Router({
  linkActiveClass: 'navigation__active',
  routes: [
    {
      path: '/(report)?',
      name: 'ReportQueryInfo',
      component: ReportQueryInfo
    },
    {
      path: '/report/:device_id(\\d+)',
      name: 'ReportRepairFast',
      component: ReportRepairFast
    },
    {
      path: '/report/full',
      name: 'ReportRepair',
      component: ReportRepair
    },
    {
      path: '/repair',
      name: 'RepairList',
      component: RepairList
    },
    {
      path: '/repair/:id',
      name: 'ViewRepairForm',
      component: ReportView
    },
    {
      path: '/repair/:id/service',
      name: 'ViewServiceTicket',
      component: ReportServiceTicketView
    },
    {
      path: '/info',
      name: 'UserInfo',
      component: UserInfo
    },
    // {
    //   path: '/dbg',
    //   name: 'Dashboard',
    //   component: Dashboard
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js